import { mount } from "@vue/test-utils";
import Gracias from "@/views/Gracias";

jest.mock("@/views/Gracias", () => ({
  ...jest.requireActual("@/views/Gracias"),
  methods: {
    dispatch: jest.fn(),
    getImage: jest.fn()
  }
}));

describe("Gracias test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(Gracias);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component Gracias", () => {
    expect(wrapper).toBeDefined();
  });
});
